export default class Channels {
  constructor() {
    this.whatsapp = {
      status: 'disconnected', // Os status podem ser: ['disconnected', 'available', 'paused', 'in_attendance', 'processing', 'scheduled_pause']
      onHold: {},
    };
    this.voice = {
      status: 'disconnected',
      onHold: {},
    };
    this.chat = {
      status: 'disconnected',
      onHold: {},
    };
  }
}
